var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('el-row',[_c('el-col',{attrs:{"span":18,"push":3}},[_c('div',{staticClass:"box"},[_c('dash-board-item',{staticClass:"dash-item",attrs:{"data":_vm.data}}),_c('dash-board-item',{staticClass:"dash-item",attrs:{"data":_vm.data}})],1)])],1)}
var staticRenderFns = []

export { render, staticRenderFns }